import React from "react";
import { useState, useEffect, useRef } from 'react';
import { useTranslation } from "react-i18next"; // Импортируем хук перевода
// ✅ импортируем все картинки
import img1 from "../assets/slider/1.png";
import img2 from "../assets/slider/2.png";
import img3 from "../assets/slider/3.png";
import img4 from "../assets/slider/4.png";
import img5 from "../assets/slider/5.png";
import img6 from "../assets/slider/6.png";
import img7 from "../assets/slider/7.png";
import img8 from "../assets/slider/8.png";
import img9 from "../assets/slider/9.png";
import img10 from "../assets/slider/10.png";
import img11 from "../assets/slider/11.png";
import img12 from "../assets/slider/12.png";
import img13 from "../assets/slider/13.png";
import img14 from "../assets/slider/14.png";
import img15 from "../assets/slider/15.png";
import img16 from "../assets/slider/16.png";

const Slider = () => {
    const { t } = useTranslation();
  // ✅ теперь массив правильный
  const data = [
    img1, img2, img3, img4,
    img5, img6, img7, img8,
    img9, img10, img11, img12,
    img13, img14, img15, img16,
  ];
const sliderRef = useRef(null);
const pos = useRef(0);

useEffect(() => {
  const move = () => {
    pos.current -= 1; // Скорость
    if (sliderRef.current) {
      // Когда дошли до половины (дублированного контента), прыгаем в 0
      if (pos.current <= -1000) pos.current = 0; 
      sliderRef.current.style.transform = `translateX(${pos.current}px)`;
    }
    requestAnimationFrame(move);
  };
  
  requestAnimationFrame(move);
}, []);
  return (
      <section className="w-full overflow-hidden py-[100px] flex justify-center items-center flex-col gap-12">
         <h1 className="font-['Cormorant_Garamond'] text-[#0058a3] uppercase text-[20px] md:text-[64px] tracking-[0.15em]">
       {t("partners_title")}
        </h1>
      <div ref={sliderRef} className="flex w-max">
        {[...data, ...data].map((img, i) => (
          <div
            key={i}
            className="w-[200px] h-[200px] max-sm:w-[150px] max-sm:h-[100px] mx-[40px] p-[20px] border border-gray-300 flex items-center justify-center"
          >
            <img src={img} className="w-full h-full object-contain" />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Slider;